export default __webpack_public_path__ + "static/media/99HuntersLogoIcon.aef901f2.svg";